export default class SiteHeader {

  /**
   *
   */
  static init() {

    this.last_scroll_position = 0;
    this.scroll_tick = false;

    this.main_elm = document.querySelector('.site-header');

    if(!this.main_elm) {
      return;
    }

    this.body_elm = document.querySelector('body');
    this.container_elm = this.main_elm.querySelector('.container');
    this.brand_elm = this.main_elm.querySelector('.site-header__brand');
    this.site_alert_active = this.body_elm.classList.contains('has-site-alert');

    this.initPageHeader1Actions();
    this.initSearchForm();
    this.initNav();
    this.bindOnScrollEvent();

  }

  /**
   *
   */
  static bindOnScrollEvent() {

    if(this.page_header_elm_bottom === false && !this.site_alert_active) {
      return;
    }

    window.addEventListener('scroll', function() {

      SiteHeader.last_scroll_position = window.pageYOffset;

      if(!SiteHeader.scroll_tick) {
        window.requestAnimationFrame(function() {

          if(SiteHeader.page_header_elm_bottom !== false) {

            SiteHeader.body_elm.setAttribute(
              'data-page-header-scrolled-past',
              (SiteHeader.last_scroll_position > SiteHeader.page_header_elm_bottom - SiteHeader.main_elm.getBoundingClientRect().top - 25 ? '1' : '0')
            );

          }

          if(SiteHeader.site_alert_active) {
            if (SiteHeader.last_scroll_position > 44) {
              SiteHeader.body_elm.classList.add('scrolled-past-site-alert');
            } else {
              SiteHeader.body_elm.classList.remove('scrolled-past-site-alert');
            }
          }

          SiteHeader.scroll_tick = false;

        });

      }
      SiteHeader.scroll_tick = true;

    });

  }

  /**
   *
   */
  static initSearchForm() {

    this.search_form_elm = this.main_elm.querySelector('.site-header [data-search-form]');

    if(!this.search_form_elm) {
      return;
    }

    this.search_form_input_text_elm = this.search_form_elm.querySelector('[type="text"]');
    this.search_form_submit_elm = this.search_form_elm.querySelector('[type="submit"]');

    this.initSearchFormToggler();

    document.addEventListener('click', function( event ) {
      if (SiteHeader.search_form_elm !== event.target && !SiteHeader.search_form_elm.contains(event.target)) {
        SiteHeader.handleMainSearchFormTogglerClick(event, 'hide');
      }
    });

  }

  /**
   *
   */
  static initSearchFormToggler() {

    this.show_search_form_trigger_elm = document.querySelector('.site-header [data-toggle-main-search-form-trigger="1"]');
    this.show_search_form_trigger_elm.addEventListener('click', this.handleMainSearchFormTogglerClick)

  }

  /**
   *
   */
  static handleMainSearchFormTogglerClick(event, force) {

    force = typeof force !== 'undefined' ? force : false;

    if(force === 'hide' || SiteHeader.main_elm.classList.contains('site-header--search-form-visible')) {
      // Hide form

      SiteHeader.main_elm.classList.remove('site-header--search-form-visible');
      SiteHeader.main_elm.classList.add('site-header--search-form-not-visible');

    } else {
      // Show form

      SiteHeader.main_elm.classList.add('site-header--search-form-visible');
      SiteHeader.main_elm.classList.remove('site-header--search-form-not-visible');

      SiteHeader.search_form_input_text_elm.focus();

      SiteHeader.closeNav();

    }

    event.stopPropagation();

  }

  /**
   *
   */
  static initNav() {

    this.nav_elm = document.querySelector('#main-navigation');

    if(!this.nav_elm) {
      return;
    }

    this.animating_nav = false;

    this.nav_wrapper_1_elm = document.querySelector('.main-navigation-wrapper-1');
    this.nav_wrapper_2_elm = document.querySelector('.main-navigation-wrapper-2');
    this.nav_opener_elm = document.querySelector('[data-nav-opener="1"]');
    this.nav_closer_elm = document.querySelector('[data-nav-closer="1"]');

    this.nav_status = 'closed';

    this.initNavOpenerElm();
    this.initNavCloserElm();

  }

  /**
   *
   */
  static initNavOpenerElm()
  {

    this.nav_opener_elm.addEventListener('click', function(event) {

      event.preventDefault();

      if(SiteHeader.nav_status === 'open' || SiteHeader.animating_nav) {
        return;
      }

      this.animating_nav = true;

      SiteHeader.nav_opener_elm.setAttribute('aria-expanded', 'true');
      SiteHeader.nav_closer_elm.setAttribute('aria-expanded', 'true');

      if(window.innerWidth <= 576) {

        SiteHeader.openNavOnSmallScreens();

      } else {

        SiteHeader.calculateNavOpenOnLargeScreens();

      }

    });

  }

  /**
   *
   */
  static openNavOnSmallScreens() {

    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--visible');
    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--vertical');

    SiteHeader.animating_nav = false;
    SiteHeader.nav_status = 'open';

    SiteHeader.body_elm.classList.add('main-navigation-open');

  }

  /**
   *
   */
  static calculateNavOpenOnLargeScreens()
  {

    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--calculating');

    let nav_wrapper_elm_fits_horizontal = SiteHeader.navWrapperElmFitsHorizontal();

    if(nav_wrapper_elm_fits_horizontal) {

      SiteHeader.openNavHorizontal();

    } else {

      SiteHeader.openNavVertical();

    }

  }

  /**
   *
   */
  static openNavHorizontal()
  {

    let nav_wrapper_1_width = SiteHeader.nav_wrapper_1_elm.offsetWidth;
    let nav_wrapper_2_width = SiteHeader.nav_wrapper_2_elm.offsetWidth;

    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--calculating');

    SiteHeader.main_elm.classList.add('site-header--horizontal-navigation');

    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--horizontal');
    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--opening');
    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--visible');
    SiteHeader.nav_wrapper_1_elm.style.width = (nav_wrapper_1_width + 1) + 'px';
    SiteHeader.nav_wrapper_2_elm.style.width = (nav_wrapper_2_width + 1) + 'px';

    window.setTimeout(function() {

      SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--opening');
      SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--open');

      SiteHeader.animating_nav = false;
      SiteHeader.nav_status = 'open';

    }, 300);

  }

  /**
   *
   */
  static openNavVertical()
  {

    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--calculating');

    SiteHeader.main_elm.classList.add('site-header--vertical-navigation');

    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--visible');
    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--vertical');
    //SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--opening');

    SiteHeader.animating_nav = false;
    SiteHeader.nav_status = 'open';

    SiteHeader.body_elm.classList.add('main-navigation-open');

  }

  /**
   *
   */
  static initNavCloserElm()
  {

    this.nav_closer_elm.addEventListener('click', function(event) {

      event.preventDefault();

      if(SiteHeader.nav_status === 'closed' || SiteHeader.animating_nav) {
        return;
      }

      SiteHeader.closeNav();

    });

  }

  /**
   *
   */
  static closeNav()
  {

    this.animating_nav = true;

    SiteHeader.nav_opener_elm.setAttribute('aria-expanded', 'false');
    SiteHeader.nav_closer_elm.setAttribute('aria-expanded', 'false');
    SiteHeader.main_elm.classList.remove('site-header--horizontal-navigation');
    SiteHeader.main_elm.classList.remove('site-header--vertical-navigation');

    if(window.innerWidth <= 576) {

      SiteHeader.closeNavOnSmallScreens();

    } else {

      SiteHeader.closeNavOnLargeScreens();

    }

    this.body_elm.classList.remove('main-navigation-open');

  }

  /**
   *
   */
  static closeNavOnSmallScreens()
  {

    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--open');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--horizontal');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--vertical');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--visible');

    SiteHeader.nav_status = 'closed';
    SiteHeader.animating_nav = false;

  }

  /**
   *
   */
  static closeNavOnLargeScreens()
  {

    if(SiteHeader.nav_wrapper_1_elm.classList.contains('main-navigation-wrapper-1--horizontal')) {

      SiteHeader.closeHorizontalNav();

    } else {

      SiteHeader.closeVerticalNav();

    }

  }

  /**
   *
   */
  static closeHorizontalNav()
  {

    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--closing');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--open');

    window.setTimeout(function() {

      SiteHeader.nav_wrapper_1_elm.style.removeProperty('width');
      SiteHeader.nav_wrapper_2_elm.style.removeProperty('width');

      SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--horizontal');
      SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--vertical');
      SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--visible');
      SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--closing');

      SiteHeader.nav_status = 'closed';
      SiteHeader.animating_nav = false;

    }, 400);

  }

  /**
   *
   */
  static closeVerticalNav()
  {

    SiteHeader.nav_wrapper_1_elm.style.removeProperty('width');
    SiteHeader.nav_wrapper_2_elm.style.removeProperty('width');

    SiteHeader.nav_wrapper_1_elm.classList.add('main-navigation-wrapper-1--closing');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--open');

    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--horizontal');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--vertical');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--visible');
    SiteHeader.nav_wrapper_1_elm.classList.remove('main-navigation-wrapper-1--closing');

    SiteHeader.nav_status = 'closed';
    SiteHeader.animating_nav = false;

  }

  /**
   *
   */
  static navWrapperElmFitsHorizontal()
  {

    return SiteHeader.nav_wrapper_1_elm.offsetWidth < SiteHeader.getAvailableSpace();

  }

  /**
   *
   * @returns {*}
   */
  static getAvailableSpace()
  {

    return SiteHeader.container_elm.offsetWidth - SiteHeader.brand_elm.offsetWidth - 240;

  }

  /**
   *
   */
  static initPageHeader1Actions()
  {

    SiteHeader.page_header_elm_bottom = false;

    let page_header_elm = document.querySelector('.page-header-type-1');

    if(!page_header_elm) {
      return;
    }

    SiteHeader.page_header_elm_bottom = page_header_elm.getBoundingClientRect().bottom;

    window.onresize = function() {
      SiteHeader.page_header_elm_bottom = page_header_elm.getBoundingClientRect().bottom + window.scrollY;
    }

    /*window.addEventListener('scroll', function() {
      SiteHeader.body_elm.setAttribute('data-page-header-scrolled-past', (window.pageYOffset > SiteHeader.page_header_elm_bottom ? '1' : '0'));
    });*/

    window.dispatchEvent(new Event('resize'));
    window.dispatchEvent(new Event('scroll'));

  }

}
